var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C6C6C6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "store-solid",
    className: "st0",
    d: "M90.6,26.19l-8.96-14.18c-0.81-1.28-2.22-2.05-3.74-2.05H22.1c-1.51,0-2.92,0.77-3.74,2.05 L9.38,26.19c-4.63,7.32-0.53,17.5,8.12,18.67c0.63,0.08,1.26,0.12,1.89,0.12c3.89,0,7.6-1.65,10.2-4.54 c5.08,5.63,13.76,6.08,19.39,1c0.35-0.32,0.69-0.65,1-1c5.08,5.63,13.76,6.08,19.39,1c0.35-0.32,0.69-0.65,1-1 c2.6,2.89,6.31,4.54,10.2,4.54c0.63,0,1.26-0.04,1.89-0.12c8.68-1.16,12.79-11.34,8.15-18.67L90.6,26.19z M83.1,49.83h-0.02 C82.25,49.94,81.4,50,80.55,50c-1.88,0-3.74-0.28-5.54-0.83v20.85H24.97V49.15C23.17,49.72,21.29,50,19.4,50 c-0.85,0-1.7-0.06-2.55-0.17h-0.01c-0.63-0.09-1.26-0.21-1.88-0.36v30.56c0,5.53,4.48,10.01,10.01,10.01h50.05 c5.53,0,10.01-4.48,10.01-10.01V49.47C84.4,49.63,83.75,49.75,83.1,49.83z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.d4abf3d637bdbc0687ff90f0ed3fdf99.svg";
export { ForwardRef as ReactComponent };